@if (formUpdating) {
  <div class="margin-form-overlay">
    <mat-spinner diameter=32></mat-spinner>
  </div>
}
<form (ngSubmit)="submit()" [formGroup]="marginForm" class="margin-form-container">
  <mat-form-field>
    <mat-label i18n>General Expenses</mat-label>
    <input formControlName="generalExpenses" i18n-placeholder matInput placeholder="General Expenses" type="number">
    <span matSuffix>%</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label i18n>Commission</mat-label>
    <input formControlName="commission" i18n-placeholder matInput placeholder="Commission" type="number">
    <span matSuffix>%</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label i18n>Profit</mat-label>
    <input formControlName="profit" i18n-placeholder matInput placeholder="Profit" type="number">
    <span matSuffix>%</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label i18n>Custom Duties</mat-label>
    <input formControlName="customDuties" i18n-placeholder matInput placeholder="Custom Duties" type="number">
    <span matSuffix>%</span>
  </mat-form-field>
  <button (submit)="submit()" [disabled]="!marginForm.valid" mat-button type="submit">Save</button>
</form>
